import { render, staticRenderFns } from "./AutoStartSelector.vue?vue&type=template&id=966dd646&lang=pug&"
import script from "./AutoStartSelector.vue?vue&type=script&lang=js&"
export * from "./AutoStartSelector.vue?vue&type=script&lang=js&"
import style0 from "./AutoStartSelector.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/node/authoring/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('966dd646')) {
      api.createRecord('966dd646', component.options)
    } else {
      api.reload('966dd646', component.options)
    }
    module.hot.accept("./AutoStartSelector.vue?vue&type=template&id=966dd646&lang=pug&", function () {
      api.rerender('966dd646', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/inspector/specific/AutoStartSelector.vue"
export default component.exports